/* eslint-disable */
export default {
  copyToClipboard: 'Copiar al portapapeles',
} as const;

// @key: @#@"copyToClipboard"@#@ @source: @#@"Copy to Clipboard"@#@
